import { useLoaderData } from 'react-router';

import { QueryClient } from '@tanstack/react-query';

import { referralMany } from '../react-query/key-fn';

export const referralManyLoader = (queryClient: QueryClient) => async () => {
  return queryClient.ensureQueryData(referralMany());
};

export const useFromLoader = () =>
  useLoaderData<ReturnType<typeof referralManyLoader>>();
